import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import icClose from '@iconify/icons-ic/twotone-close';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'form-modal-delete-cofirm-base',
  styles: [
    `
      .example-viewport {
        height: 300px;
        width: 100%;
        border: 1px solid #e0e0e0;
      }

      .example-item {
        height: auto;
        min-height: 36px;
        padding: 4px 8px;
      }

      .message-container {
        margin-bottom: 12px;
        font-size: 14px;
      }
    `,
  ],
  template: `
    <ng-container>
      <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
        <div>{{ title }}</div>
        <button type="button" mat-icon-button (click)="close(false)" tabindex="-1">
          <mat-icon [icIcon]="icClose"></mat-icon>
        </button>
      </div>

      <mat-dialog-content>
        <div class="message-container">
          {{ message }}
        </div>

        <cdk-virtual-scroll-viewport itemSize="36" class="example-viewport">
          <mat-list>
            <mat-list-item *cdkVirtualFor="let item of list" class="example-item">
              {{ item }}
            </mat-list-item>
          </mat-list>
        </cdk-virtual-scroll-viewport>
      </mat-dialog-content>

      <mat-dialog-actions align="end">
        <button mat-button color="primary" [loading]="loading" (click)="close(true)">OK</button>
      </mat-dialog-actions>
    </ng-container>
  `,
})
export class FormModalConfirmWithListComponent implements OnInit {
  title: string;
  message: string;
  list: string[];
  loading = false;

  icClose = icClose;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      message: string;
      list: string[];
    },
    private dialog: MatDialogRef<FormModalConfirmWithListComponent>,
  ) {
    if (data) {
      this.title = data.title;
      this.message = data.message;
      this.list = data.list;
    }
  }

  ngOnInit() {}

  close(bool: boolean) {
    this.dialog.close(bool);
  }
}
